
<div class="card shadow border border-{{colour}} h-100"
  [class.card-disabled]="disabled">
  <div class="card-body d-flex align-items-center text-{{colour}}">

    <!-- LEFT: Icon + Title -->
    <div class="d-flex align-items-center gap-2">
      <em class="{{icon}} text-{{colour}} fs-4"></em>

      <span class="fw-bold text-truncate">
        {{ headerText }}
      </span>
    </div>

    <!-- PUSH EVERYTHING RIGHT -->
    <div class="ms-auto d-flex align-items-center gap-3">

      <!-- COUNT right aligned -->
      <div class="text-end">
        <ng-container *ngIf="isBusy; else valueBlock">
          <em class="fa fa-spinner fa-pulse"></em>
        </ng-container>

        <ng-template #valueBlock>
          <span class="card-value">
            {{ value | shortNumber }}
          </span>
        </ng-template>
      </div>

      <!-- INFO ICON -->
      <ejs-tooltip [isSticky]="false">
        <ng-template #content>
          {{ toolTipText }}
        </ng-template>

        <span class="d-inline-flex align-items-center">
          <i class="fa-solid fa-circle-info fs-5"></i>
        </span>
      </ejs-tooltip>

    </div>

  </div>
</div>
